module.exports = __webpack_public_path__ + "static/media/xfinity-logo.14a1fe44.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/xfinity-logo.png
// module id = 7352
// module chunks = 4